module.exports = __webpack_public_path__ + "assets/img/replace-product-contact-agent.56e00f2d.svg";